var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_457","data-name":"Group 457","transform":"translate(-698.646 -244.646)"},React.createElement("g",{"id":"Group_456","data-name":"Group 456","transform":"translate(-445.5 -248.5)"},[React.createElement("line",{"id":"Line_139","data-name":"Line 139","x2":"15","y2":"15","transform":"translate(1144.5 493.5)","fill":"none","stroke":"#f3efd7","strokeWidth":"1","key":0}),React.createElement("line",{"id":"Line_140","data-name":"Line 140","x1":"15","y2":"15","transform":"translate(1144.5 493.5)","fill":"none","stroke":"#f3efd7","strokeWidth":"1","key":1})])));
}

Close.defaultProps = {"width":"15.707","height":"15.707","viewBox":"0 0 15.707 15.707"};

module.exports = Close;

Close.default = Close;
